// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"06b6089b","182":"7fcd9335","312":"4045886a","376":"49b3b9a3","551":"fe394973","575":"83306376","624":"eb46f626","893":"6fe81dac","965":"ef1b1077"}[chunkId] + ".chunk.js";
};